// FetchTheMovieDB.js

import { getResponseContent, RequestError } from './Response'; // Assuming this file is in the same directory as services folder
import config from '../utils/ApiRoute';
import { Navigate } from 'react-router';

async function makeRequest(endpoint, method, data, token, form) {
    const headers = {};
    // Check if data is present and determine the content type accordingly
    if (form) {
        //  headers['Content-Type'] = `multipart/form-data; boundary=<calculated when request is sent>`;
    } else {
        headers['Content-Type'] = 'application/json';
    }
    const storedToken = localStorage.getItem("AuthToken");
    if (storedToken) {
        headers.Authorization = `Bearer ${storedToken ? JSON.parse(storedToken) : ""}`;
    }

    const response = await fetch(`${endpoint}`, {
        method,
        headers,
        body: data
    });

    const content = await getResponseContent(response);
    if (response.ok) return content;

    // let errorMessage = '';
    // var t_content = content || {}
    // if (t_content && t_content?.message) {
    //     errorMessage = t_content?.message;
    // } else {
    //     errorMessage = response.statusText;
    // }
    // throw new RequestError(errorMessage, response.status, t_content);
    let errorMessage = content?.message || response.statusText;
    throw new RequestError(errorMessage, response.status, content);

}

const FetchData = async (endpoint, method, data, token, form, bypassCache = false) => {
    try {
        // --- CUSTOM CACHE LOGIC FOR EMPLOYEE LISTS ---
        if (method === 'GET' && typeof endpoint === 'string' && !bypassCache) {
            const isAllList = endpoint.includes('employee/listall');
            const isReportList = endpoint.includes('employee/list_reporting') && !endpoint.includes('dept_id') && !endpoint.includes('sub_dept_id');

            if (isAllList || (isReportList && endpoint.includes('emp_id='))) {
                const cacheKey = `cached_${endpoint}`;
                const cachedEntry = sessionStorage.getItem(cacheKey);

                if (cachedEntry) {
                    try {
                        const parsed = JSON.parse(cachedEntry);
                        // 5-minute cache
                        if (Date.now() - parsed.timestamp < 5 * 60 * 1000) {
                            return parsed.data;
                        }
                    } catch (e) {
                        // ignore broken cache
                    }
                }

                const response = await makeRequest(endpoint, method, data, token, form);
                if (response && response.status !== false) {
                    sessionStorage.setItem(cacheKey, JSON.stringify({
                        timestamp: Date.now(),
                        data: response
                    }));
                }
                return response;
            }
        }
        // ----------------------------------------------

        return await makeRequest(endpoint, method, data, token, form);
    } catch (error) {
        console.log("error", error)
        var t_error = error || {}
        if (t_error && t_error?.message == 'Token has expired!') {
            const lang = localStorage.getItem('lang');
            const userTypeStr = localStorage.getItem('userType');
            let isAdmin = false;

            if (userTypeStr) {
                isAdmin = (parseInt(userTypeStr) === 1);
            } else {
                const tokenStr = localStorage.getItem('token');
                if (tokenStr) {
                    try {
                        const tokenData = JSON.parse(tokenStr);
                        isAdmin = (tokenData?.type === 1);
                    } catch (e) {
                        // Ignore parse error
                    }
                }
            }

            localStorage.clear();
            if (lang) localStorage.setItem('lang', lang);
            
            // Re-store userType so if they refresh, they stay on the right login portal
            if (userTypeStr) localStorage.setItem('userType', userTypeStr);
            
            window.location.href = isAdmin ? "/admin-login" : "/login";
        }
        throw t_error;
    }
};

export default FetchData;

